import createSar from 'app/modules/fincenSarOld/sagas/createSar';
import createNewSar from 'app/modules/fincenSarOld/sagas/createNewSar';
import archiveSar from 'app/modules/fincenSarOld/sagas/archiveSar';

const sagaRegistry = [createSar, createNewSar, archiveSar];

export default sagaRegistry;
